import { render } from "./LeaveTypeCreateEditModal.vue?vue&type=template&id=518e1d83"
import script from "./LeaveTypeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./LeaveTypeCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__